export const moduleConfig = {
    entityKey: 'subscriptionItems',
    titles: {
        singular: 'Subscription Item',
        plural: 'Subscription Items'
    }
}

export const initialSortState = {
    column: 'position',
    direction: 'asc',
};